import React from 'react';
import axios from 'axios';
import { Form, Input, message } from 'antd';

import apiPath from 'apiPath';
import AddressInput from 'components/AddressInput';
import SaveButton from 'components/SaveButton';
import stickyError from 'components/stickyError';
import withSpin from 'components/withSpin';
import stickyErrorAdmissions from 'components/stickyError';

class TranscriptAddress extends React.Component {
	state = {
		schoolName: null,
		address: null,
		city: null,
		state: null,
		zip: null,
		country: null,
		groupLoaded: false,
		hasShownNotFoundError: false
	}
	showAddressNotFoundError = (name) => {
		if (this.state.hasShownNotFoundError) return;
		if (name) stickyErrorAdmissions('Can\'t find transcript address for ' + name, 0, true);
		else stickyError('Can\'t find transcript address', 0, true);
		this.setState({ hasShownNotFoundError: true });
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((errors, values) => {
			if (errors) {
				const firstErrorMessage = errors[Object.keys(errors)[0]].errors[0].message;
				stickyError('Validation error: ' + firstErrorMessage, 4.5);
				this.props.isSubmitted();
			}
			else {
				axios.put(apiPath+'/group', values, {withCredentials: true})
					.then(result => {
						if (result.data.Result.Status === 'R') throw({message: result.data.Result.Message});
						this.props.isSubmitted();
						message.success('Saved!');
					}).catch(error => {
						stickyError(error.message);
						console.error(error);
						this.props.isSubmitted();
					});
			}
		});
	}
	getTranscriptAddress = (props) => {
		if (props.isGapOrPost) {
			const {
				Forename, Surname, Street, City, Province, PostalCode, Country
			} = this.props.folio;
			this.setState({
				schoolName: Forename + ' ' + Surname,
				address: Street,
				city: City,
				state: Province,
				zip: PostalCode,
				country: Country
			});
		}
		else if (!this.state.groupLoaded) {
			axios.get(apiPath+'/group', {withCredentials: true}).then(result => {
				let s = { groupLoaded: true };
				if (result.data[0] !== undefined ) {
					s.schoolName = result.data[0].folSurname;
					s.address = result.data[0].adrStreet1
					s.city = result.data[0].adrCity;
					s.state = result.data[0].State;
					s.zip = result.data[0].adrPostalCode;
					s.country = result.data[0].Country;
				} else {
					this.showAddressNotFoundError(props.agency.Name);
				}
				this.setState(s);
			}).catch(error => {
				console.error(error);
			});
		}
		// else if (props.agency) {
		// 	const name = props.agency.Name;
		// 	this.setState({schoolName: name});
		// 	this.showAddressNotFoundError(name);
		// }
	}
	componentDidMount() { this.getTranscriptAddress(this.props); }
	componentWillReceiveProps(nextProps) { this.getTranscriptAddress(nextProps); }
	render() {
		if (this.props.variant !== 'admin') {
			const redirect = this.props.redirectIfHidden(this.props, 'academic/transcriptaddress');
			if (redirect) return redirect;
		}

		const { getFieldDecorator } = this.props.form;
		return (
			<Form onSubmit={this.handleSubmit} className="withSpacing">

				{this.props.variant !== 'admin' &&
					<p>
						One official Colorado State University (hard copy) transcript -- posted via USPS first-class mail following your Semester at Sea voyage -- is included in your tuition and fees.
						<br />
						<br />  
						See here the transcript mailing address on record. <font style={{fontWeight: 'bold', textDecorationLine: 'underline'}}>Please verify that we have the correct transcript mailing address.</font> If you do not complete this check, your official transcript may be sent to the wrong address, office or recipient, for which ISE cannot be held responsible. Nor can additional/replacement transcripts be posted as a courtesy. This will delay the transfer of your credits.
						<br />
						<br /> 
						<font style={{fontWeight: 'bold'}}>If you believe the mailing address, listed office, and/or recipient is incorrect, please send a message to</font> <a href="mailto:programadministration@isevoyages.org">programadministration@isevoyages.org</a>, identifying the correct address. ISE will confirm the change with your home institution. If the change is confirmed, the address will be updated. If your home institution advises that the current address on record is correct, we will advise you.
					</p>
				}
				{this.props.variant === 'admin' &&
					<p>
						If the student is a Gap Year or Post Graduate student, their transcript will be sent to their personal address.
						Otherwise, it will be sent to the address shown here. Changes made to this address will apply to all students from the associated school.
					</p>
				}

				{this.props.isGapOrPost === false &&
					<Form.Item label="School" style={{padding:'4pt 0 4pt 8pt'}}>
						{getFieldDecorator('schoolName', {
							initialValue: (this.props.agency && this.props.agency.Name)? this.props.agency.Name: this.state.schoolName
						})(<Input disabled />)}
					</Form.Item>
				}
				<legend>Address</legend>
				<AddressInput
					form={this.props.form}
					disabled={this.props.variant !== 'admin' || this.props.isGapOrPost === true}
					address={{
						Street: this.state.address,
						City: this.state.city,
						Province: this.state.state,
						PostalCode: this.state.zip,
						Country: this.state.country
					}}
					getFieldDecorator={getFieldDecorator} />
				
				{this.props.variant === 'admin' &&
					<SaveButton
						disabled={!this.props.form.isFieldsTouched()}
						loading={this.props.getStatus().submitting}  />
				}

			</Form>
		);
	}
}

export default withSpin(Form.create()(TranscriptAddress));


// WEBPACK FOOTER //
// ./portal-components/Portal/Academic/TranscriptAddress.jsx